import { Response, HeaderCondition, DetailCondition } from '../models/stock-summary-master.model';
import { MockService } from '../../../core/services/mock.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environment';
import { Observable, map, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { Option } from 'src/app/base/models/option.model';

@Injectable({
  providedIn: 'root',
})
export class StockSummaryService {
  // 測試範例為了模擬資料查詢時間，實際開發不會用到
  delay: number = 500;
  
  private orgs: Option[] = [];

  constructor(
    private readonly mockService: MockService,
    private readonly httpClient: HttpClient
  ) {}

  /**
   * 因為 Org 清單不會頻繁改變，所以透過 orgs 變數保存資料。
   * 如果取到值了，之後都用這個值直接回傳，不用每次都重新查詢。
   *
   * @param keyword Org 查詢關鍵字，不傳就是查全部
   */
  getOrgs(keyword?: string): Observable<Option[]> {
    // 如果已經有儲存的所有 Org 就從裡面篩選
    if (this.orgs && this.orgs.length > 0) {
      const filteredOrgs = this.orgs.filter(org =>
        keyword ? org.label.toLowerCase().includes(keyword.toLowerCase()) : true
      );
      return of(filteredOrgs);
    }

    let endpoint = `${environment.apiEndpoint}/user/orgs`;

    endpoint = this.mockService.parseApiEndpoint(endpoint, '/api/v1/item360/orgs.json');
    return this.httpClient.get<{ orgId: string, ouFullName: string }[]>(endpoint).pipe(
      map(response => {
          this.orgs = response.map(org => ({
            id: org.orgId,
            value: org.orgId,
            label: org.orgId + ' - ' + org.ouFullName
          }));

        return this.orgs.filter(org =>
          keyword ? org.label.toLowerCase().includes(keyword.toLowerCase()) : true
        );
      })
    );
  }

  queryStockSummaryMasterHeaderDatas(
    condition: HeaderCondition
  ): Observable<Response> {
    let endpoint = `${environment.apiEndpoint}/stock/header`;
    endpoint = this.mockService.parseApiEndpoint(
      endpoint,
      '/api/v1/item360/stock/header.json'
    );
    if (environment.apiMock) {
      return this.httpClient.get<Response>(endpoint);
    }
    return this.httpClient.post<Response>(endpoint, condition);
  }
  
  queryStockSummaryMasterDetailDatas(condition: DetailCondition): Observable<Response> {
    let endpoint = `${environment.apiEndpoint}/stock/detail`;
    endpoint = this.mockService.parseApiEndpoint(
      endpoint,
      '/api/v1/item360/stock/detail.json'
    );
    if (environment.apiMock) {
      return this.httpClient.get<Response>(endpoint);
    }
    return this.httpClient.post<Response>(endpoint, condition);
  }
}
